/**
 * Canonical application feature flag keys
 * These keys must match exactly with GrowthBook feature keys (kebab-case)
 */
export enum VeroFlag {
  useAttachmentsRedesign = "use-attachments-redesign",
  enablePaymentAccountMapping = "enable-payment-account-mapping",
  enableSearchService = "enable-search-service",
  useSearchService = "use-search-service",
  copyInviteLinkDisabled = "copy-invite-link-disabled",
  hideMoveToAnotherApplicationButton = "use-app-hide-move-to-another-application-button",
  hideRemoveFromApplicationButton = "use-app-hide-remove-from-application-button",
  useAppSummaryTabRestructure = "use-app-summary-tab-restructure",
  allowMoreActionOptions = "allow-more-action-options",
  useShowIcraaClickWrapModal = "use-show-icraa-click-wrap-modal",
  useRillAnalytics = "use-rill-analytics",
  veroCopilot = "vero-copilot",
  useDealsListUiRedesign = "use-deals-list-ui-redesign",
  canEditDealConfiguration = "can-edit-deal-configuration",
  useV1ExpressionEngine = "use-v1-expression-engine",
  useV1IncomeFlow = "use-v1-income-flow",
  useInternationalDocumentUpload = "international-income-ocr",
  useIntlOcrFixes = "use-intl-ocr-fixes",
  useV1AppReEntry = "use-v1-app-re-entry",
  useShowAffordableUnitBadge = "use-show-affordable-unit-badge",
  useDocumentRunwayCalculation = "use-document-runway-calculation",
  useConfigurableDocQuantities = "use-configurable-doc-quantities",
  applicantSafeIncomeExclusionCtas = "applicant-safe-income-exclusion-ctas",
  customerioSnippetEnabled = "customerio-snippet-enabled",
  enableMonthlyIncomeDisplayProduct1486 = "enable-monthly-income-display-PRODUCT-1486",
  useYardiApprovedNoVeroStatus = "use-yardi-approved-no-vero-status-PRODUCT-1522",
  useDealListApiEnhancementTI2464 = "use-deal-list-api-enhancement-TI-2464",
  disableManualInviteApplicantsProduct1805 = "disable-manual-invite-applicants-PRODUCT-1805",
  useDealSummaryRedesignProduct1270 = "use-deal-summary-redesign-PRODUCT-1270",
  /** Camden Legal Audit — hide income/bank/asset document contents client-side */
  legalAuditDocumentRedactionProduct1772 = "legal-audit-document-redaction-PRODUCT-1772",
  /** Deal Summary: drop the per-applicant "Application:" progress pill, keep only Status */
  hideApplicationProgressProduct1348 = "hide-application-progress-PRODUCT-1348",
  /** Income stream tables: show the bank account each stream came from */
  displayIncomeStreamBankAccountProduct1957 = "display-income-stream-bank-account-PRODUCT-1957",
  /** Applicant Status pill: "Approved – Not submitted in VERO" for approved applications without a VERO submit */
  enableDecisionedApplicationLockProduct2611 = "enable-decisioned-application-lock-PRODUCT-2611",
  /** Validate phone numbers as E.164 (libphonenumber) and send normalized values */
  usePhoneNormalizationProduct2732 = "use-phone-normalization-PRODUCT-2732",
}

/**
 * Default values for all feature flags
 * Used as fallback when GrowthBook is not ready
 */
export const DEFAULT_FLAG_VALUES: Record<VeroFlag, boolean> = {
  [VeroFlag.useAttachmentsRedesign]: false,
  [VeroFlag.enablePaymentAccountMapping]: false,
  [VeroFlag.enableSearchService]: false,
  [VeroFlag.useSearchService]: false,
  [VeroFlag.copyInviteLinkDisabled]: false,
  [VeroFlag.useAppSummaryTabRestructure]: false,
  [VeroFlag.allowMoreActionOptions]: false,
  [VeroFlag.useShowIcraaClickWrapModal]: false,
  [VeroFlag.useRillAnalytics]: false,
  [VeroFlag.veroCopilot]: false,
  [VeroFlag.hideMoveToAnotherApplicationButton]: false,
  [VeroFlag.hideRemoveFromApplicationButton]: false,
  [VeroFlag.useDealsListUiRedesign]: false,
  [VeroFlag.canEditDealConfiguration]: false,
  [VeroFlag.useV1ExpressionEngine]: false,
  [VeroFlag.useV1IncomeFlow]: false,
  [VeroFlag.useInternationalDocumentUpload]: false,
  [VeroFlag.useIntlOcrFixes]: false,
  [VeroFlag.useV1AppReEntry]: false,
  [VeroFlag.useShowAffordableUnitBadge]: false,
  [VeroFlag.useDocumentRunwayCalculation]: false,
  [VeroFlag.useConfigurableDocQuantities]: false,
  [VeroFlag.applicantSafeIncomeExclusionCtas]: false,
  [VeroFlag.customerioSnippetEnabled]: false,
  [VeroFlag.enableMonthlyIncomeDisplayProduct1486]: false,
  [VeroFlag.useYardiApprovedNoVeroStatus]: false,
  [VeroFlag.useDealListApiEnhancementTI2464]: false,
  [VeroFlag.disableManualInviteApplicantsProduct1805]: false,
  [VeroFlag.useDealSummaryRedesignProduct1270]: false,
  [VeroFlag.legalAuditDocumentRedactionProduct1772]: false,
  [VeroFlag.hideApplicationProgressProduct1348]: false,
  [VeroFlag.displayIncomeStreamBankAccountProduct1957]: false,
  [VeroFlag.enableDecisionedApplicationLockProduct2611]: false,
  [VeroFlag.usePhoneNormalizationProduct2732]: false,
};
